import has from 'lodash/has';
import toLower from 'lodash/toLower';

const restrictedTiers = ['FREE', 'TRIAL', 'FREE_FOREVER', 'SELF_SIGNUP_TRIAL'];

export const getOrgTierInfo = (orgInfo = {}) => {
  let orgTierInfo = {
    isRestrictedTier: false,
    restrictedTierName: null,
    accountTypeMessage: null,
    tierLimitMessage: null,
  };

  if (has(orgInfo, 'org_tier') && orgInfo.org_tier) {
    const { display_name, name, id, ...tierLimits } = orgInfo.org_tier;
    orgTierInfo.isRestrictedTier = restrictedTiers.includes(name);

    if (orgTierInfo.isRestrictedTier) {
      orgTierInfo.accountTypeMessage = `Account Type: ${display_name}`;
      orgTierInfo.restrictedTierName = display_name;

      let recordCount =
        has(tierLimits, 'record_count_limit') && tierLimits.record_count_limit !== -1
          ? `${tierLimits.record_count_limit / 1000000}M`
          : null;

      let recordCountMessage = recordCount ? `${recordCount} records` : null;
      let recordCountMsgSubText = '';

      if (recordCountMessage && has(tierLimits, 'record_count_limit_time')) {
        recordCountMsgSubText += `${toLower(tierLimits.record_count_limit_time)}`;
      }
      recordCountMessage += ` ${recordCountMsgSubText}`;

      let activeSourceCount =
        has(tierLimits, 'data_source_count_limit') && tierLimits.data_source_count_limit !== -1
          ? `${tierLimits.data_source_count_limit}`
          : null;
      let activeSourceCountMessage = activeSourceCount
        ? `${activeSourceCount} active sources`
        : null;

      let separator = activeSourceCountMessage && recordCountMessage ? ' , ' : '';

      orgTierInfo.tierLimitMessage = `Usage Limits: ${recordCountMessage}${separator}${activeSourceCountMessage}`;

      orgTierInfo.counts = {
        usage: {
          value: recordCount,
          subText: recordCount ? `records ${recordCountMsgSubText}` : null,
        },
        active_sources: {
          value: activeSourceCount,
          subText: null,
        },
      };
    }
  }

  return orgTierInfo;
};
